
export default function authHeader() {
      return {    
        'x-api-key': '27102023',
        'Content-Type': 'application/json'
    };
   
  }